import * as Api from "@api";
import React from "react";
import { CaptionedImage } from "../CaptionedImage/CaptionedImage";
import { PageContent } from "../Page";

export interface ImageGalleryListProps<Keys extends readonly string[]>
{
    captionProps?: Partial<Omit<React.ComponentProps<typeof PageContent>, "data" | "type">>;
    className?: string;
    imageDirectory: string;
    imageHeight?: number;
    imageWidth?: number;
    keys: Keys;
    layout?: React.ComponentProps<typeof CaptionedImage>["layout"];
    onGetItem: (key: Keys[number], captionedImageProps: React.ComponentProps<typeof CaptionedImage>) => React.ReactNode;
    pageContent?: Api.Content<Keys[number]>;
}

export const ImageGalleryList = <Keys extends readonly string[]>({ captionProps, className, imageDirectory, imageHeight, imageWidth, keys, layout, onGetItem, pageContent, ...props }: ImageGalleryListProps<Keys>): React.FunctionComponentElement<ImageGalleryListProps<Keys>> =>
    <div {...props} className={className}>
        {
            keys.map(key => 
            {
                const pc = pageContent !== undefined ? Api.ContentService.getItem(pageContent, key) : undefined;
                return onGetItem(key, {
                    captionProps: pc !== undefined ? { ...pc, ...captionProps } : undefined,
                    imageProps: {
                        alt: pc !== undefined ? pc.data : key,
                        height: imageHeight,
                        src: `${imageDirectory}${key}.png`,
                        width: imageWidth,
                    },
                    layout,
                });
            })
        }
    </div>;
